import React, { useState } from 'react';
import { Table } from 'reactstrap';
import { BiDownArrowAlt, BiUpArrowAlt } from "react-icons/bi";

const headingStyle = {
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer',
  width: '25%',
  border: '0px'
};

const UsersTableHeader = ({ updateBy,role }) => {
  const [sortState, setSortState] = useState({
    field: '',
    order: ''
  });

  const handleSortBy = (field) => {

     console.log("field:upa", sortState,'order:', field)
    const newOrder = 
      sortState.field === field && sortState.order === 'asc' 
      ? 'desc' 
      : sortState.field === field && sortState.order === 'desc'
      ? 'default' 
      : 'asc'; 

    setSortState({ field, order: newOrder });
    console.log("field:", field,'order:', newOrder)
    updateBy(field, newOrder); 
  };

  const renderSortArrow = (field) => {
    if (field === sortState.field) {
      return sortState.order === 'asc' ? <BiUpArrowAlt size={"22px"} /> : <BiDownArrowAlt size={"22px"} />;
    }
    return <BiDownArrowAlt size={"22px"} />;
  };
  const getHeading=()=>{
    if(role==='Admin') return 'Mobile Number'
    if(role==='User'|| role==='Member') return ''
    return'Phone Number'
  }
console.log("issues:",role,!['User','Member'].includes(role))
  return (
    <Table bordered hover responsive>
      <thead>
        <tr style={{ display: 'flex', borderBottom: '2px solid #dee2e6', background: '#f78961ff' }}>
          <th style={headingStyle} onClick={() => handleSortBy('name')}>
            Name {renderSortArrow('name')}
          </th>
          <th style={headingStyle} onClick={() => handleSortBy('email')}>
            Email {renderSortArrow('email')}
          </th>
          <th style={headingStyle} onClick={() => handleSortBy('mobileNumber')}>
            {getHeading()} {!['User','Member'].includes(role)&&renderSortArrow('mobileNumber')}
          </th>
          <th style={headingStyle}>
           {/* Actions */}
          </th>
        </tr>
      </thead>
    </Table>
  );
};

export default UsersTableHeader;
